var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("app-select-journal", {
        attrs: { fancy: "", value: _vm.singleValue, label: _vm.label },
        on: {
          input: function ($event) {
            return _vm.setValue($event)
          },
        },
      })
    : _c("app-multi-select-journal", {
        attrs: { fancy: "", value: _vm.inputValues, label: _vm.label },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }